import React from 'react';
import SingleValueIcon from '@splunk/dashboard-visualizations/SingleValueIcon';
import VisualizationDocPage from '@splunk/visualizations-shared/VisualizationDocPage';
import EncodingDoc from '@splunk/dashboard-visualizations/common/EncodingDoc';
import EventsDoc from '@splunk/dashboard-visualizations/common/EventsDoc';
import OptionsDoc from '@splunk/dashboard-visualizations/common/OptionsDoc';
import DocExample from '@splunk/react-docs/DocExample';

import BasicCode from '!!raw-loader!./examples/Basic';
import BackgroundColorWhiteCode from '!!raw-loader!./examples/BackgroundColorWhite';
import FieldFooCode from '!!raw-loader!./examples/FieldFoo';
import FieldBarCode from '!!raw-loader!./examples/FieldBar';
import FixIconCode from '!!raw-loader!./examples/FixIcon';
import FixIconAfterCode from '!!raw-loader!./examples/FixIconAfter';
import FixIconTopCode from '!!raw-loader!./examples/FixIconTop';
import FixIconBelowCode from '!!raw-loader!./examples/FixIconBelow';
import FixIconNoValuesCode from '!!raw-loader!./examples/FixIconNoValues';
import NoIconCode from '!!raw-loader!./examples/NoIcon';
import IconByThresholdCode from '!!raw-loader!./examples/IconByThreshold';
import IconOpacityCode from '!!raw-loader!./examples/IconOpacity';
import IconColorCode from '!!raw-loader!./examples/IconColor';
import ColorDataSeriesCode from '!!raw-loader!./examples/ColorDataSeries';
import EncodingColumnIndexCode from '!!raw-loader!./examples/EncodingColumnIndex';
import EncodingFormatCode from '!!raw-loader!./examples/EncodingFormat';
import EncodingFormatColumnIndexCode from '!!raw-loader!./examples/EncodingFormatColumnIndex';
import RemoteIconCode from '!!raw-loader!./examples/RemoteIcon';

import BasicExample from './examples/Basic';
import BackgroundColorWhiteExample from './examples/BackgroundColorWhite';
import FieldFooExample from './examples/FieldFoo';
import FieldBarExample from './examples/FieldBar';
import FixIconExample from './examples/FixIcon';
import FixIconAfterExample from './examples/FixIconAfter';
import FixIconTopExample from './examples/FixIconTop';
import FixIconBelowExample from './examples/FixIconBelow';
import FixIconNoValuesExample from './examples/FixIconNoValues';
import NoIconExample from './examples/NoIcon';
import IconByThresholdExample from './examples/IconByThreshold';
import IconOpacityExample from './examples/IconOpacity';
import IconColorExample from './examples/IconColor';
import ColorDataSeriesExample from './examples/ColorDataSeries';
import EncodingColumnIndexExample from './examples/EncodingColumnIndex';
import EncodingFormatExample from './examples/EncodingFormat';
import EncodingFormatColumnIndexExample from './examples/EncodingFormatColumnIndex';
import RemoteIconExample from './examples/RemoteIcon';

import doc from './definition';
import optionsSchema from '../optionsSchema';

export default () => (
    <VisualizationDocPage
        title="Dashboard Single Value Icon"
        description="This visualization has been upgraded in @splunk/visualizations/SingleValueIcon and may be used in UDF."
        examplesSection={[
            <DocExample
                title="Basic Single Value Icon with default icon"
                key="basic"
                code={BasicCode}
                example={BasicExample}
            />,
            <DocExample
                title="Basic Single Value Icon. Background Color is white."
                key="backgroundwhite"
                code={BackgroundColorWhiteCode}
                example={BackgroundColorWhiteExample}
            />,
            <DocExample
                title="Encoding Field is foo"
                key="fieldfoo"
                code={FieldFooCode}
                example={FieldFooExample}
            />,
            <DocExample
                title="Encoding Field is bar"
                key="fieldbar"
                code={FieldBarCode}
                example={FieldBarExample}
            />,
            <DocExample
                title="Single Value Icon with fixed icon"
                key="fixicon"
                code={FixIconCode}
                example={FixIconExample}
            />,
            <DocExample
                title="Single Value Icon with fixed icon located after value and trend indicator"
                key="fixiconafter"
                code={FixIconAfterCode}
                example={FixIconAfterExample}
            />,
            <DocExample
                title="Single Value Icon with fixed icon located on top of value and trend indicator"
                key="fixicontop"
                code={FixIconTopCode}
                example={FixIconTopExample}
            />,
            <DocExample
                title="Single Value Icon with fixed icon located below value and trend indicator"
                key="fixiconbelow"
                code={FixIconBelowCode}
                example={FixIconBelowExample}
            />,
            <DocExample
                title="Single Value Icon with fixed icon, value and trend indicator are invisible"
                key="fixiconnovalues"
                code={FixIconNoValuesCode}
                example={FixIconNoValuesExample}
            />,
            <DocExample
                title="Single Value Icon is invisible"
                key="noicon"
                code={NoIconCode}
                example={NoIconExample}
            />,
            <DocExample
                title="Single Value Icon, icon by threshold"
                key="iconbythreshold"
                code={IconByThresholdCode}
                example={IconByThresholdExample}
            />,
            <DocExample
                title="Single Value Icon, icon opacity is 0.2"
                key="iconopacity"
                code={IconOpacityCode}
                example={IconOpacityExample}
            />,
            <DocExample
                title="Single Value Icon, icon color is blue"
                key="iconcolor"
                code={IconColorCode}
                example={IconColorExample}
            />,
            <DocExample
                title="Single Value Icon, color data series specified"
                key="colordataseries"
                code={ColorDataSeriesCode}
                example={ColorDataSeriesExample}
            />,
            <DocExample
                title="Encoding column index specified"
                key="encodingcolumnindex"
                code={EncodingColumnIndexCode}
                example={EncodingColumnIndexExample}
            />,
            <DocExample
                title="Encoding format specified"
                key="encodingformat"
                code={EncodingFormatCode}
                example={EncodingFormatExample}
            />,
            <DocExample
                title="Encoding format column index specified"
                key="encodingformatcolumnindex"
                code={EncodingFormatColumnIndexCode}
                example={EncodingFormatColumnIndexExample}
            />,
            <DocExample
                title="Persisted Icon in IconRegistry"
                key="remoteIcon"
                description="Single Value Icon example with remote icon key"
                code={RemoteIconCode}
                example={RemoteIconExample}
            />,
        ]}
        encodingSection={<EncodingDoc encoding={doc.encoding} />}
        optionSection={<OptionsDoc options={optionsSchema} />}
        eventSection={
            <EventsDoc
                events={doc.events}
                Visualization={SingleValueIcon}
                options={{
                    icon: 'clock',
                }}
                encoding={{}}
                dsState={{
                    primary: {
                        data: {
                            columns: [
                                ['1', '62', '103', '308', '587', '876', '930', '1320'],
                                [
                                    '2018-08-19T00:00:00.000+00:00',
                                    '2018-08-20T00:00:00.000+00:00',
                                    '2018-08-21T00:00:00.000+00:00',
                                    '2018-08-22T00:00:00.000+00:00',
                                    '2018-08-23T00:00:00.000+00:00',
                                    '2018-08-24T00:00:00.000+00:00',
                                    '2018-08-25T00:00:00.000+00:00',
                                    '2018-08-26T00:00:00.000+00:00',
                                ],
                            ],
                            fields: [
                                {
                                    name: 'foo',
                                },
                                {
                                    name: '_time',
                                },
                            ],
                        },
                        meta: {},
                    },
                }}
            />
        }
    />
);
